import { createSelector } from 'reselect';
import { REMAINING_TIME_ESTIMATE } from '../../../model/constants';
import type { TrackingEntityState } from '../../reducers/entities/tracking/types';
import type { State } from '../../types';
import { getEntities } from '../entities';

export const getTracking = (state: State): TrackingEntityState => getEntities(state).tracking;

export const getIsRemainingTimeTrackingEnabledSelector = createSelector(
	getTracking,
	({ fieldId, isEnabled }: TrackingEntityState) => fieldId === REMAINING_TIME_ESTIMATE && isEnabled,
);
